import {Injectable} from '@angular/core';
import { EnvironmentService } from './environment.service';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {Observable, catchError, throwError} from 'rxjs';
import { InitiateRequest } from '../models/initiateRequest';



@Injectable({
  providedIn: 'root',
})
export class SimilarityService {
  httpWithoutInterceptor: HttpClient;

  constructor(
      private envService: EnvironmentService,
      private http: HttpClient,
      private httpBackend: HttpBackend,
  ) {
    this.httpWithoutInterceptor = new HttpClient(this.httpBackend);
  }
}
